module.exports = __webpack_public_path__ + "static/media/view.e21a71a3.svg";